import React, {useEffect, useState} from "react";
import {MDBBox, MDBCol, MDBRow, MDBTypography} from "mdbreact";
import VideoTutorial from "./videoTutorial/videoTutorial-query-container";
import {useQuery} from "@apollo/react-hooks";
import {FETCH_PRODUCT} from "../../catalog/product/queries";

const OpitonsArkansas = ({
catalogNoMap,
setActiveCatalogNo,
activeCatalogNo,
activeCatalogNoPossition,
setActiveCatalogNoPossition
}) => {
    const [hasModel, setHasModel] = useState(false);
    const [isImgError, setIsImgError] = useState(false);



    return(
        <div>

            {!isImgError && (

                <MDBBox
                    style={{marginTop:"0",marginBottom: "1rem",paddingTop:"0"}}
                    className="catalog-items d-flex"
                    role="group"
                    aria-label="Variations"
                >

                    { Array.isArray(catalogNoMap) ? catalogNoMap?.map((item, index)=>{

                        return (
                            <button
                                type="button"
                                key={item?.product?.sku || index}
                                className="catalog-item-btn mr-2"
                                style={{"height" : "57px", "width" : "57px"}}
                                aria-label={item?.product?.sku}
                                aria-pressed={activeCatalogNo === item?.product?.sku}
                                onClick={() => {
                                    setActiveCatalogNoPossition(index);
                                    //     handleCatalogNoSelectOption(item, "CATA");
                                        setActiveCatalogNo(item?.product?.sku);

                                }}
                            >
                                <img
                                    style={{ "width" : "100%"}}
                                    src={item?.product?.image?.url}
                                    // onError={onError}
                                    alt=""
                                    className={
                                        activeCatalogNo === item?.product?.sku
                                            ? `catalog-item-active cursor-pointer`
                                            : `catalog-item cursor-pointer`
                                    }
                                />


                            </button>
                        )
                    }) : (
                        <button
                            type="button"
                            className="catalog-item-btn mr-2"
                            style={{"height" : "70px", "width" : "70px"}}
                            aria-label={catalogNoMap?.sku}
                            aria-pressed={!!activeCatalogNo}
                            onClick={() => {
                                setActiveCatalogNoPossition(0);
                                //     handleCatalogNoSelectOption(item, "CATA");
                                setActiveCatalogNo(catalogNoMap?.sku);
                                //     setActiveCatalogNo(index);
                            }}
                        >
                            <img
                                style={{ "width" : "100%"}}
                                src={catalogNoMap?.image?.url}
                                // onError={onError}
                                alt=""
                                className={
                                    activeCatalogNo
                                        ? `catalog-item-active cursor-pointer`
                                        : `catalog-item cursor-pointer`
                                }
                            />


                        </button>
                        )}
                </MDBBox>
            ) || <></>}
        </div>
    );
}

export default OpitonsArkansas;